module.exports = __webpack_public_path__ + "img/yibao.91edf7ec.png";